import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as companyActions from '../../../actions/companyActions';
import * as sortableListActions from '../../../actions/common/sortableListActions';
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';


class ShowDeletedCompaniesButton extends React.Component {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);

    }

    onClick(event) {
        const direction = this.props.sortableList.asc ? 'ASC' : 'DSC';
        this.props.actions.updateList(
            this.props.listId,
            companyActions.loadCompanies,
            this.props.sortableList.column,
            direction,
            [1],
            this.props.sortableList.search,
            +!this.props.sortableList.withDeleted,
            this.props.sortableList.portalId || ''
        );
    }

    _applyStyles() {
        if(this.props.mobile) {
            return 'col-sm-12'
        }
        if(this.props.tablet) {
            return 'pull-right';
        }
        return ''
    }

    render() {
        return (
            <button
                onClick={this.onClick}
                className={`btn btn-primary waves-effect ${this._applyStyles()}`}>
                {
                    this.props.sortableList.withDeleted ?
                        this.props.intl.formatMessage(messages.showDeletedCompaniesButtonHide) :
                        this.props.intl.formatMessage(messages.showDeletedCompaniesButtonShow)
                }
            </button>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        companies: state.companies,
        sortableList: state.sortableList[ownProps.listId] || {withDeleted: true},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                sortableListActions
            ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ShowDeletedCompaniesButton));


// WEBPACK FOOTER //
// ./web/src/components/company/list/ShowDeletedCompaniesButton.jsx